angular.module('clientDashboardApp')
  .directive('listingPhoto', () => {
    return {
      restrict: 'E',
      template: `
          <div>
             <div>
              <figure class="listing-image mb-0">
                <div ng-show="shouldShow()" class="listing-image-bounding-box">
                  <img image-adjust 
                       ng-if="ngModel.photoURLs[0]" ng-src="{{ngModel.photoURLs[0]}}" width="237"
                       height="140"
                       alt="" onError="this.onerror=null;this.src='/images/no-photos-found.png';" class="img-responsive img-height-bound">
                  <img ng-if="!ngModel.photoURLs[0]" ng-src="images/no-photos-found.png" width="237"
                       height="140"
                       alt="" class="img-responsive img-height-bound"/>
                </div>
                <div ng-show="!shouldShow()" class="listing-image-bounding-box">
                  <div style="padding: 25px">
                    <h4>Photos</h4>
                    <h4> N/A</h4>
                  </div>
                </div>
            </figure>
            </div>
          </div>
      `,
      scope: {
        ngModel: '='
      },
      controller: ($scope, providerService) => {
        $scope.shouldShow = () => {
          const p = providerService.getProvider($scope.ngModel.contentProvider);
          return !p || p.displaySettings.displaysImages;
        }
      }
    }
  })
